import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Tabs from 'wix-style-react/src/Tabs'
import { Notification } from 'wix-style-react'

import TemplatesTab from './TemplatesTab'
import AppsTab from './AppsTab'
import { LIGHTEST_GRAY, media } from '../styles'

/**
 * Sidebar(left) section of dashboard page
 */

const Container = styled.div`
  ${media.small`flex: 0 0 660px;`}
  ${media.normal`flex: 0 0 660px;`}
  ${media.huge`flex: 0 0 660px;`}

  padding: 3px 0 10px 0;
  border-right: 1px solid ${LIGHTEST_GRAY};
  box-shadow: 1px 0 5px 0 rgba(41,85,115,0.21);

  font-size: 20px;
  background: white;
  // & li:first-of-type {
  //   color: #83CBCA;
  // }
  // & li:last-of-type {
  //   color: #83CBCA;
  // }
`

class DashboardSidebar extends Component {

  constructor (props) {
    super(props)
    const isMyApps = props.tabName === 'myApps'
    this.state = {
      activeTab: isMyApps ? 2 : 1,
      hasTemplatesNotificationAppeared: false,
      hasMyAppsNotificationAppeared: isMyApps,
    }
  }

  onItemClick = (item) => {
    this.props.selectTemplate('')
    this.setState({
      activeTab: item.id
    })
  }

  setHasNotificationShown = (templates) => {
    if (templates) {
      this.setState({
        hasTemplatesNotificationAppeared: true
      })
    } else {
      this.setState({
        hasMyAppsNotificationAppeared: true
      })
    }
  }

  renderNotificationBar (text, templates) {
    return (
      <Notification
        onClose={() => this.setHasNotificationShown(templates)}
        show
        size='big'
        theme='standard'
        type='local'
        zIndex={10000}
        timeout={3000}
      >
        <Notification.TextLabel>
          {text}
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
    )
  }

  render () {
    // console.log('state **** ', this.state)
    return (
      <Container>
        <Tabs
          activeId={this.state.activeTab}
          hasDivider={false}
          items={[
            { id: 1, title: 'CREATE NEW' },
            { id: 2, title: 'MY APPS' }
          ]}
          type='uniformFull'
          onClick={this.onItemClick}
        />
        {(this.state.activeTab === 1)
          ? (!this.state.hasTemplatesNotificationAppeared) ? this.renderNotificationBar('Select a Template from the options below', true) : null
          : (!this.state.hasMyAppsNotificationAppeared) ? this.renderNotificationBar('Select one of your Instant Apps to edit', false) : null}
        {(this.state.activeTab === 1)
          ? <TemplatesTab
            templates={this.props.templates}
            selectedTemplateId={this.props.selectedTemplateId}
            selectTemplate={this.props.selectTemplate} />
          : <AppsTab
            apps={this.props.apps}
            selectedAppId={this.props.selectedAppId}
            selectApp={this.props.selectApp} />}
      </Container>
    )
  }
}

DashboardSidebar.propTypes = {
  templates: PropTypes.array,
  selectedTemplateId: PropTypes.string,
  selectTemplate: PropTypes.func,
  apps: PropTypes.array,
  selectedAppId: PropTypes.string,
  selectApp: PropTypes.func,
  tabName: PropTypes.string
}

export default DashboardSidebar



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardSidebar.js